import {
  ICoinsPurchased,
  ISellCoinsCampaign,
  IPayouts,
  IPerformancePagination
} from '@/models/performance';
import { Campaign } from '@/models/marketingCenter/sellCoins';
import APIService from '.';

export default class SellCoinsService extends APIService {
  getCoinsPurchaseHistory(resource: string, params: Record<string, any> = {}) {
    return this.get<IPerformancePagination<ICoinsPurchased>>(resource, {
      params
    });
  }

  getPayoutHistory(resource: string, params: Record<string, any> = {}) {
    return this.get<IPerformancePagination<IPayouts>>(resource, {
      params
    });
  }

  getActiveCampaign() {
    return this.get<Campaign>(`/admin/sell-coin-campaign/active`);
  }

  getAutomaticCampaign() {
    return this.get<Campaign>(`/admin/sell-coin-campaign/automatic`);
  }

  listOfCampaigns(query?: string, data?: any) {
    return this.get(query || '/admin/sell-coin-campaign', query ? {} : data);
  }

  detailOfCampaign(id: string) {
    return this.get<Campaign>(`/admin/sell-coin-campaign/${id}`);
  }

  createSellingCoinsCampaign(data: ISellCoinsCampaign) {
    return this.post('/admin/sell-coin-campaign', data);
  }

  changeCampaignStatus(id: string) {
    return this.put(`/admin/sell-coin-campaign/${id}/status`);
  }

  updateCampaign(id: string, body: any) {
    return this.put(`/admin/sell-coin-campaign/${id}`, body);
  }

  deactivateActiveCampaign() {
    return this.put(`/admin/sell-coin-campaign/disable-active-campaign`);
  }
}
